export const SET_SEARCH = 'search/SET_SEARCH';
export const GET_SEARCH = 'search/GET_SEARCH';
export const TOGGLE_SEARCH = 'search/TOGGLE_SEARCH';



// WEBPACK FOOTER //
// ./src/app/containers/Search/constants.js